export default __webpack_public_path__ + "static/media/tele.86170223.svg";